export const AUTH_HEADER = 'authorization';
export const SKIP_AUTH_HEADER = 'skip-auth';
export const CONTENT_TYPE = 'Content-Type';

export const TOKEN_DUMMY_USER = 'ywQSO5NvnubUl0tggRtpjX37csu2';
export const GUEST_ID = 'guest-id';

export const DUMMY_PHONE_NUMBER = '1234567890';
